import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	 userinfor:{}
  },
  getters: {
  },
  mutations: {
	  setuserinfor(state, payload) {
	    state.userinfor = payload
	  }
  },
  actions: {
  },
  modules: {
  }
})
